import { render } from "./MobileStatusTabs.vue?vue&type=template&id=50fc32ec&scoped=true&ts=true"
import script from "./MobileStatusTabs.vue?vue&type=script&lang=ts"
export * from "./MobileStatusTabs.vue?vue&type=script&lang=ts"

import "./MobileStatusTabs.vue?vue&type=style&index=0&id=50fc32ec&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50fc32ec"]])

export default __exports__